import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'antd/dist/antd.min.css';
import App from './App';
import { Router, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import './views/views-dir.less';


ReactDOM.render( 
        <Router history={createBrowserHistory()}>
            <Route component={App}/>
        </Router>
, document.getElementById('root'));